import icons from '../../build/svg-icons.html';
const iconsNode = document.createElement('div');
iconsNode.innerHTML = icons;
iconsNode.style.display = 'none';

document.body.appendChild(iconsNode);